<div class="backdrop" *ngIf="show">
  <img class="loader" src="../../../../assets/images/loader.gif" alt="loader" width="60px"/>
</div>
